import { sessionHeaders } from "./client";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Anonymous per-browser identity so saved scenarios / autosaves are isolated per user without a
// login. Persisted in localStorage; sent as X-Client-Id on every projects request. When the user is
// logged in the backend scopes data to their account (cross-device) instead of this id.
const CLIENT_KEY = "dsymbia_client_id";
export function getClientId() {
  try {
    let id = localStorage.getItem(CLIENT_KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || `c_${Date.now()}_${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(CLIENT_KEY, id);
    }
    return id;
  } catch {
    return "anonymous";
  }
}

async function j(res) {
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// Every projects call carries the signed app-session (+ auth cookies). ensureSession is awaited via
// sessionHeaders so a request never fires before the server has issued a session.
const opts = async (method, body) => ({
  method,
  credentials: "include",
  headers: await sessionHeaders(body !== undefined ? { "Content-Type": "application/json" } : {}),
  ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
});

export const projectsApi = {
  list: async () => fetch(`${BASE}/api/projects`, await opts("GET")).then(j),
  get: async (id) => fetch(`${BASE}/api/projects/${id}`, await opts("GET")).then(j),
  create: async (body) => fetch(`${BASE}/api/projects`, await opts("POST", body)).then(j),
  update: async (id, body) => fetch(`${BASE}/api/projects/${id}`, await opts("PUT", body)).then(j),
  remove: async (id) => fetch(`${BASE}/api/projects/${id}`, await opts("DELETE")).then(j),
  autosave: async (project_name, payload) =>
    fetch(`${BASE}/api/projects/autosave`, await opts("POST", { project_name, payload })).then(j),
  getAutosave: async (project_name) =>
    fetch(`${BASE}/api/projects/autosave/${encodeURIComponent(project_name)}`, await opts("GET")).then(j),
  // ---- Collaboration (shared sessions) ----
  listShared: async () => fetch(`${BASE}/api/projects/shared`, await opts("GET")).then(j),
  collaborators: async (id) => fetch(`${BASE}/api/projects/${id}/collaborators`, await opts("GET")).then(j),
  addCollaborator: async (id, email, role) =>
    fetch(`${BASE}/api/projects/${id}/collaborators`, await opts("POST", { email, role })).then(j),
  removeCollaborator: async (id, email) =>
    fetch(`${BASE}/api/projects/${id}/collaborators/remove`, await opts("POST", { email })).then(j),
  inviteLink: async (id, role) =>
    fetch(`${BASE}/api/projects/${id}/invite-link`, await opts("POST", { role })).then(j),
  join: async (invite_code) => fetch(`${BASE}/api/projects/join`, await opts("POST", { invite_code })).then(j),
  presence: async (id) => fetch(`${BASE}/api/projects/${id}/presence`, await opts("POST", {})).then(j),
};
